var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRegulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "-3 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-728.977 -117.86)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 29,
    transform: "translate(738.477 160.36)",
    strokeWidth: 3,
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 10,
    transform: "translate(760.477 165.36)",
    strokeWidth: 3,
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.922,0H39a0,0,0,0,1,0,0V10a0,0,0,0,1,0,0H4.891A4.891,4.891,0,0,1,0,5.109V4.922A4.922,4.922,0,0,1,4.922,0Z",
    transform: "translate(729.477 155.36)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.477,155.36h35a1,1,0,0,0,1-1V119.675c0-.552-.448-1.315-1-1.315H736.209a7.013,7.013,0,0,0-6.732,7.079V160.36",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 36,
    transform: "translate(736.477 119.36)",
    strokeWidth: 3,
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.643,131.443c0,.848-2.092,1.273-2.4,2.01-.317.764.85,2.541.275,3.117s-2.354-.591-3.117-.275c-.737.306-1.162,2.4-2.01,2.4s-1.272-2.092-2.009-2.4c-.764-.316-2.542.85-3.117.275s.591-2.353.274-3.117c-.3-.737-2.4-1.162-2.4-2.01s2.093-1.272,2.4-2.009c.317-.764-.85-2.542-.274-3.117s2.353.591,3.117.274c.737-.305,1.162-2.4,2.009-2.4s1.273,2.093,2.01,2.4c.764.317,2.541-.85,3.117-.274s-.592,2.353-.275,3.117C758.551,130.171,760.643,130.6,760.643,131.443Z",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x2: 13,
    transform: "translate(747.477 143.36)",
    strokeWidth: 3,
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 13,
    transform: "translate(747.477 147.36)",
    strokeWidth: 3,
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulation);
export default __webpack_public_path__ + "static/media/Regulation.551bb499c288eef9a8b5076bb01c5a5e.svg";
export { ForwardRef as ReactComponent };